import { render, staticRenderFns } from "./Parties.vue?vue&type=template&id=820d4b26&"
import script from "./Parties.vue?vue&type=script&lang=js&"
export * from "./Parties.vue?vue&type=script&lang=js&"
import style0 from "./Parties.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports